module.exports = __webpack_public_path__ + "static/pad_path_demo-f4d22d491b1b7fc32944c4f848ce82e4.gif";